import React, { Component, useState } from 'react';
import { Container, FormControl } from '@material-ui/core';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import * as stationAction from '../actions/stationNames'
import '../style/main.scss';
import ErrorBoundary from '../common/errorBoundary'
import '../components/flightDetail/flightDetail.global.scss'
import { Select } from '@material-ui/core';
import { MenuItem } from '@material-ui/core';
import FormLabel from '@material-ui/core/FormLabel';
import * as flightDetailsActions from '../actions/flightDetails'
import * as StationsActions from '../actions/stationNames'
import FlightCard from '../components/flightDetail/flightCard'
import flightSchedule from './flightSchedule';
import LocalStorageHelper from '../common/localStorageHelper';
import Button from '@material-ui/core/Button';
import * as config from '../data/config'

const StationName = (props) => {

  let { flightFilters: currentFlightFilters, onFlightFilter, handleClose, allFlights, allStations } = props

  //currentFlightFilters.flightNumberFilters = currentFlightFilters.flightFilters;
  //currentFlightFilters.stationFilter = allStations;
  //currentFlightFilters.stationFilter = allStations;
  const [flightFilters, setFlightFilters] = React.useState(currentFlightFilters)

  console.info("const flightFilters const", flightFilters);  

  const error = false;
  const onSetStations = (e) => {
           
    let selected = e.target.value
    //console.info("selected", selected)

    let user = LocalStorageHelper.getUser();
    //let uu =  "https://localhost:44377/api/v1/flightDetails/"+ selected;
    //let api = config.environment.api;
    //let uu = api.baseURL + api.getFlightDetailsURL+ selected;
    let uu = "https://timex-api.flyporter.com/api/v1/flightDetails/" + selected;
    console.info("uu final done", uu);
    let token = '';
    currentFlightFilters.stationFilter = allStations;

    //console.info("all sskk", currentFlightFilters.stationFilter)

    let updatedFilter = { ...flightFilters } 

    //console.info("initial updatedFilter", updatedFilter);
   // setFlightFilters(updatedFilter)
    
    if(selected){
      
      if (user && user.token) {
        token = user.token;        
    } 


//call api 
return fetch(           
 uu,          
    {   
              
     headers: { 
       'Authorization': token  
               
      }              
     }                     
   )
       
   .then(response => response.json())

   .then(data => {
     console.info("ttkk", data.flightDetails)

     // query to save in updatde filter
     updatedFilter.stationFilter = updatedFilter.stationFilter.filter(abc => abc == selected)
     setFlightFilters(updatedFilter) 
     //console.info("initial updatedFilter after response", updatedFilter)

    // onFlightFilter(updatedFilter)
   // console.info("initial updatedFilter onFlightFilter  1888 flightFilters 1888", updatedFilter);

     

   // onFlightFilter(flightFilters)
   // console.info("initial updatedFilter onFlightFilter  1888 flightFilters 1888", flightFilters);
    return;
    //return data
})

    

}    

    
  }

  const applyStationsFilters = () => {
    onFlightFilter(flightFilters)
    console.info("after click on ok", flightFilters);
   // handleClose()
  }
  
  return (
    <div className="m-auto">
    <ErrorBoundary>
        <FormControl>
          
    <FormLabel>Select Station Name</FormLabel> 
       
      <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"                
          label="All Stations" 
         
          onChange={(e) => {onSetStations(e)}}                                  
      >
        <MenuItem disabled>Select Station</MenuItem>
        {
        props.allStations.map((code, name) => (
        <MenuItem value={code}>
        {code}
        </MenuItem>
        ))
        }               
</Select>
        </FormControl>

<Button 
    onClick={applyStationsFilters} >OK</Button>         
       
   </ErrorBoundary>
   </div>
)
  
      } 
   


export default StationName
    


// const mapStateToProps = (state) => {

//     const { allStations } = state.StationDetail
//     return {
//         allStations      
//     }
// }

// function mapDispatchToProps(dispatch) {
//     return { 
//         actions: bindActionCreators(Object.assign({}, stationAction), dispatch) 
//     }
// }

// export default connect(
//     mapStateToProps,
//     mapDispatchToProps
// )(StationName)